<script setup lang="ts">
import { format } from '@/utils/date-fns';
import { capitalize } from 'lodash';
import { computed } from 'vue';
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';

interface Props {
  start?: string | number | Date;
  end?: string | number | Date;
}

const props = withDefaults(defineProps<Props>(), {});

const formattedStartDate = computed(() => {
  if (!props.start) {
    return;
  }
  return capitalize(format(new Date(props.start), 'EEEE d. MMMM'));
});

const formattedEndDate = computed(() => {
  if (!props.end) {
    return;
  }
  return capitalize(format(new Date(props.end), 'EEEE d. MMMM'));
});

const formattedStartTime = computed(() => {
  if (!props.start) {
    return;
  }

  return format(new Date(props.start), 'HH:mm');
});

const formattedEndTime = computed(() => {
  if (!props.end) {
    return;
  }

  return format(new Date(props.end), 'HH:mm');
});
</script>

<template>
  <BasicBlock :icon="['fal', 'clock']" :ariaDescription="$t('global.date')">
    <div>
      <div
        v-if="formattedStartDate !== formattedEndDate"
        class="flex flex-col"
        :aria-label="`${formattedStartDate} ${formattedStartTime} ${$t('global.toDate')} ${formattedEndDate} ${formattedEndTime}`"
      >
        <p>
          {{ formattedStartDate }} -
          <span class="font-bold">{{ formattedStartTime }}</span>
        </p>

        <span>
          {{ formattedEndDate }} -
          <span class="font-bold">{{ formattedEndTime }}</span>
        </span>
      </div>

      <div v-else class="flex flex-col">
        <span :aria-label="formattedStartDate">{{ formattedStartDate }}</span>
        <span
          class="font-bold"
          :aria-label="`${formattedStartTime} - ${formattedEndTime}`"
          >{{ formattedStartTime }} - {{ formattedEndTime }}</span
        >
      </div>
    </div>
  </BasicBlock>
</template>
